import { LengthType } from "./LengthType";
import { Length } from "./Length";
import LengthValue from "./LengthValue";

export class StarLength extends Length {
    
    lengthValue?: LengthValue | undefined;
    private _value: number;
    
    constructor(value: number = 1) {
        super();
        this._value = value;
    }

    get lengthType(): LengthType {
        return LengthType.Star;
    }

    get value(): number {
        return this._value;
    }

    toString(): string {
        return this._value === 1 ? "*" : `${this._value}*`;
    }
}
